import { useCallback, useEffect, useState } from 'react';
import { toast } from 'react-toastify';

import { logError } from 'utils/logger';
import { getCandidateDetails } from '../service';

export function useCandidate(applicationId) {
  const [candidate, setCandidate] = useState(null);
  const [loading, setLoading] = useState(false);

  const fetchCandidateDetails = useCallback(async () => {
    if (!applicationId) return;
    setLoading(true);
    try {
      const data = await getCandidateDetails(applicationId);
      setCandidate(data);
    } catch (error) {
      toast.error(
        logError({
          error: error,
          message: 'Failed to fetch candidate details',
          code: 'CANDIDATE_DETAILS_FETCH_FAILED',
        }),
      );
    } finally {
      setLoading(false);
    }
  }, [applicationId]);

  useEffect(() => {
    fetchCandidateDetails();
  }, [fetchCandidateDetails]);

  return { candidate, loading, refresh: fetchCandidateDetails };
}
